/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Color theming configuration for challenge pages. Supports full brand customization.
 * @export
 * @interface ChallengeThemeColors
 */
export interface ChallengeThemeColors {
    /**
     * Primary brand color (buttons, accents, borders)
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    primary?: string;
    /**
     * Darker variant for 3D button depth effect
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    primaryDark?: string;
    /**
     * Secondary color (claim buttons, highlights)
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    secondary?: string;
    /**
     * Darker variant for 3D button depth effect
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    secondaryDark?: string;
    /**
     * Accent color for highlights and emphasis
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    accent?: string;
    /**
     * Page background color
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    background?: string;
    /**
     * Card/container background color
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    cardBackground?: string;
    /**
     * Primary text color
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    textPrimary?: string;
    /**
     * Secondary/muted text color
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    textSecondary?: string;
    /**
     * Success state color
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    success?: string;
    /**
     * Error state color
     * @type {string}
     * @memberof ChallengeThemeColors
     */
    error?: string;
}

/**
 * Check if a given object implements the ChallengeThemeColors interface.
 */
export function instanceOfChallengeThemeColors(value: object): value is ChallengeThemeColors {
    return true;
}

export function ChallengeThemeColorsFromJSON(json: any): ChallengeThemeColors {
    return ChallengeThemeColorsFromJSONTyped(json, false);
}

export function ChallengeThemeColorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeThemeColors {
    if (json == null) {
        return json;
    }
    return {
        
        'primary': json['primary'] == null ? undefined : json['primary'],
        'primaryDark': json['primaryDark'] == null ? undefined : json['primaryDark'],
        'secondary': json['secondary'] == null ? undefined : json['secondary'],
        'secondaryDark': json['secondaryDark'] == null ? undefined : json['secondaryDark'],
        'accent': json['accent'] == null ? undefined : json['accent'],
        'background': json['background'] == null ? undefined : json['background'],
        'cardBackground': json['cardBackground'] == null ? undefined : json['cardBackground'],
        'textPrimary': json['textPrimary'] == null ? undefined : json['textPrimary'],
        'textSecondary': json['textSecondary'] == null ? undefined : json['textSecondary'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function ChallengeThemeColorsToJSON(json: any): ChallengeThemeColors {
    return ChallengeThemeColorsToJSONTyped(json, false);
}

export function ChallengeThemeColorsToJSONTyped(value?: ChallengeThemeColors | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary': value['primary'],
        'primaryDark': value['primaryDark'],
        'secondary': value['secondary'],
        'secondaryDark': value['secondaryDark'],
        'accent': value['accent'],
        'background': value['background'],
        'cardBackground': value['cardBackground'],
        'textPrimary': value['textPrimary'],
        'textSecondary': value['textSecondary'],
        'success': value['success'],
        'error': value['error'],
    };
}

